/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import store from 'store/store';
import ErrorBoundary from 'components/ErrorBoundary';
import App from 'App';
import { ConfigProvider, message } from 'antd';
import esES from 'antd/es/locale/es_ES';
import 'antd/dist/antd.min.css';

const persistor = persistStore(store);

const validateMessages = {
  required: 'El campo es requerido',
  types: {
    email: 'Ingrese un correo electrónico válido',
    integer: 'Ingrese un número entero',
    url: 'Ingrese una URL válida',
  },
};

message.config({
  top: 100,
  duration: 2.5,
  maxCount: 1,
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ConfigProvider form={{ validateMessages }} locale={esES}>
          <App />
        </ConfigProvider>
      </PersistGate>
    </Provider>
  </ErrorBoundary>,
);
